class BackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)
    this.listeners.add(this, 'keydown', this.handleKeyDown)

    this.els.close.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose)
    })
  }

  get isOpen () {
    return this.getAttribute('aria-hidden') === 'false'
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
    this.returnFocus()
  }

  returnFocus () {
    if (this.activeTrigger) {
      this.activeTrigger.focus()
      this.activeTrigger = null
    }
  }

  focusFirstElement () {
    setTimeout(() => {
      const focusTarget =
        this.querySelector('button[data-back-in-stock-el="close"]') ||
        this.getFocusableElements()[0]
      if (focusTarget) focusTarget.focus()
    }, 500)
  }

  handleKeyDown (event) {
    if (!this.isOpen) return

    if (event.key === 'Escape') {
      this.handleClose()
      return
    }

    if (event.key === 'Tab') {
      this.trapFocus(event)
    }
  }

  trapFocus (event) {
    const focusableEls = this.getFocusableElements()
    if (!focusableEls.length) return

    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]

    if (event.shiftKey && document.activeElement === firstFocusableEl) {
      event.preventDefault()
      lastFocusableEl.focus()
    } else if (!event.shiftKey && document.activeElement === lastFocusableEl) {
      event.preventDefault()
      firstFocusableEl.focus()
    }
  }

  getFocusableElements () {
    return Array.from(
      this.querySelectorAll(
        'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="email"]:not([disabled]), input[type="tel"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
      ),
    ).filter(el => !el.closest('[hidden]') && el.getClientRects().length > 0)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-back-in-stock-external-el="trigger"]',
    )
    if (!trigger) return

    this.activeTrigger = document.activeElement

    await window.BAO.sectionRenderer
      .fetchSingle('back-in-stock', trigger.dataset.productUrl)
      .then(res => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')

        this.els.content.element.innerHTML = myself.innerHTML

        this.setAttribute('aria-hidden', false)
        document.body.classList.toggle('util-SiteOverflowed', true)
        this.focusFirstElement()
      })
      .then(() => {
        window.BAO.dispatchEvent(window.BAO.EVENTS.CLOSE_ALL_DRAWERS)
      })
      .catch(() => {
        this.setAttribute('aria-hidden', true)
        document.body.classList.toggle('util-SiteOverflowed', false)
        this.returnFocus()
      })
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
